import './Shop.css';

const freeFeatures = [
  { label: '1 profil enfant',                 included: true  },
  { label: 'Tâches illimitées',               included: true  },
  { label: '1 mascotte incluse',              included: true  },
  { label: '1 collection de cartes incluse',  included: true  },
  { label: '30 avatars inclus',  included: true  },
  { label: 'Le petit mot d\'EVO',  included: true  },
  { label: 'Mode autonomie global',  included: true  },
  { label: 'Bibliothèque de tâches rapides',  included: true  },
  { label: 'Configuration globale des paliers',  included: true  },
  { label: 'Notifications',  included: true  },
  { label: 'Planifications de Tâches',               included: true  },
  { label: 'Statistiques enfant',  included: true  },
  { label: 'Multilangues (FR + US)',  included: true  },
  { label: 'Boutique in-App',               included: true  },
  { label: 'Profils enfants illimités',           included: false },
  { label: 'Synchronisation dans le cloud',         included: false },
  { label: 'Statistiques par tâches',         included: false },
  { label: 'Mode autonomie par tâches',       included: false },
  { label: 'Configuration détaillées des paliers',    included: false },
  { label: '1 nouvelle mascotte incluse par mois',        included: false },
  { label: '1 nouvelle collection de cartes incluse par mois', included: false },
];

const premiumFeatures = [
  'Nombre d\'enfants illimité',
  'Tâches illimitées',
  '1 mascotte (Evo)',
  '1 collection de cartes',
  'Jusqu\'à 5 enfants',
  'Tâches illimitées & personnalisées',
  'Toutes les mascottes',
  'Collections illimitées',
  'Mode Autonomie progressif',
  'Statistiques avancées',
  'Accès prioritaire aux nouveautés',
];

const digital = [
  {
    emoji: '🎴',
    name: 'Nouvelle collection',
    desc: 'Des séries thématiques inédites — Animaux légendaires, Super-héros, Saisons… 10 cartes dont une finale animée.',
    price: '2,99 €',
    tag: 'Digital',
    tagColor: '#9B59F5',
    hot: true,
  },
  {
    emoji: '🐾',
    name: 'Nouvelle mascotte',
    desc: 'Adoptez un compagnon exclusif pour votre enfant. Chaque mascotte a ses propres animations et niveaux d\'évolution.',
    price: '1,99 €',
    tag: 'Digital',
    tagColor: '#9B59F5',
  },
];

const physical = [
  {
    emoji: '🃏',
    name: 'Cartes imprimées',
    desc: 'Commandez la collection débloquée en vrai. Format premium, impression qualité photo, livré à domicile.',
    price: 'dès 9,90 €',
    tag: 'Physique',
    tagColor: '#F59E0B',
  },
  {
    emoji: '🧸',
    name: 'Peluches & mascottes',
    desc: 'Votre mascotte préférée en version peluche. Un objet transitionnel qui prolonge l\'aventure hors de l\'écran.',
    price: 'dès 24,90 €',
    tag: 'Physique',
    tagColor: '#F59E0B',
    soon: true,
  },
  {
    emoji: '👕',
    name: 'T-shirts & sweats',
    desc: 'Des vêtements aux couleurs d\'Evolify et des mascottes — pour que l\'enfant affiche fièrement sa progression.',
    price: 'dès 19,90 €',
    tag: 'Physique',
    tagColor: '#F59E0B',
    soon: true,
  },
];

export default function Shop() {
  return (
    <section className="shop" id="boutique">
      <div className="shop__bg" />

      <div className="container">
        <div className="shop__header">
          <div className="section-label">🛍️ Boutique</div>
          <h2 className="section-title">Prolongez l'aventure</h2>
          <p className="section-subtitle">
            Nouvelles collections, mascottes inédites, et même des objets réels — tous les achats se font directement dans l'app.
          </p>
        </div>

        {/* Premium comparatif */}
        <div className="shop__group-label">⭐ Abonnement Premium</div>
        <div className="shop__premium">
          {/* Colonne Gratuit */}
          <div className="shop__plan shop__plan--free">
            <div className="shop__plan-header">
              <span className="shop__plan-icon">🆓</span>
              <h3 className="shop__plan-name">Gratuit</h3>
              <div className="shop__plan-price">0 €<span>/mois</span></div>
              <p className="shop__plan-sub">Pour découvrir Evolify</p>
            </div>
            <ul className="shop__plan-list">
              {freeFeatures.map((f, i) => (
                <li key={i} className={`shop__plan-row${!f.included ? ' shop__plan-row--no' : ''}`}>
                  <span className="shop__plan-check">{f.included ? '✓' : '✗'}</span>
                  {f.label}
                </li>
              ))}
            </ul>
            <a className="shop__plan-cta shop__plan-cta--free" href="https://www.evolify.app" target="_blank" rel="noreferrer">
              Commencer gratuitement
            </a>
          </div>

          {/* Colonne Premium */}
          <div className="shop__plan shop__plan--premium">
            <div className="shop__plan-badge">Le plus populaire</div>
            <div className="shop__plan-header">
              <span className="shop__plan-icon">✨</span>
              <h3 className="shop__plan-name">Premium</h3>
              <div className="shop__plan-price">4,99 €<span>/mois</span></div>
              <p className="shop__plan-sub">Ou 39,99 € / an — soit 4 mois offerts</p>
            </div>
            <ul className="shop__plan-list">
              {premiumFeatures.map((label, i) => (
                <li key={i} className="shop__plan-row">
                  <span className="shop__plan-check">✓</span>
                  {label}
                </li>
              ))}
            </ul>
            <a className="shop__plan-cta shop__plan-cta--premium" href="https://www.evolify.app" target="_blank" rel="noreferrer">
              Passer Premium
            </a>
          </div>
        </div>

        {/* Digital */}
        <div className="shop__group-label">🎴 Contenu digital</div>
        <div className="shop__grid shop__grid--digital">
          {digital.map((item, i) => (
            <div key={i} className={`shop__card${item.hot ? ' shop__card--hot' : ''}`}>
              {item.hot && <div className="shop__card-ribbon">Populaire</div>}
              <div className="shop__card-icon">{item.emoji}</div>
              <div className="shop__card-tag" style={{ background: item.tagColor }}>{item.tag}</div>
              <h3 className="shop__card-name">{item.name}</h3>
              <p className="shop__card-desc">{item.desc}</p>
              <div className="shop__card-footer">
                <span className="shop__card-price">{item.price}</span>
                <a className="shop__card-cta" href="https://www.evolify.app" target="_blank" rel="noreferrer">Voir dans l'app</a>
              </div>
            </div>
          ))}
        </div>

        {/* Physical */}
        <div className="shop__group-label">📦 Objets & merch</div>
        <div className="shop__grid shop__grid--physical">
          {physical.map((item, i) => (
            <div key={i} className={`shop__card${item.soon ? ' shop__card--soon' : ''}`}>
              {item.soon && <div className="shop__card-soon-badge">Bientôt</div>}
              <div className="shop__card-icon">{item.emoji}</div>
              <div className="shop__card-tag" style={{ background: item.tagColor }}>{item.tag}</div>
              <h3 className="shop__card-name">{item.name}</h3>
              <p className="shop__card-desc">{item.desc}</p>
              <div className="shop__card-footer">
                <span className="shop__card-price">{item.price}</span>
                {!item.soon && <a className="shop__card-cta" href="https://www.evolify.app" target="_blank" rel="noreferrer">Commander</a>}
                {item.soon && <span className="shop__card-soon-label">Disponible prochainement</span>}
              </div>
            </div>
          ))}
        </div>

        <div className="shop__note">
          <span>🔒</span>
          Tous les achats sont sécurisés et gérés via l'app — aucun abonnement caché, aucune surprise.
        </div>
      </div>
    </section>
  );
}
